module.exports = __webpack_public_path__ + "js/2-48e87895816ca82834b9.chunk.worker.js"